import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AcademicYearState {
  /**
   * The year the whole app is scoped to, or null to follow the school's active
   * year. Held as an id rather than a year object so it survives a reload
   * without going stale: the id is resolved against the freshly-fetched list on
   * every render, and an id belonging to another school — or to a year that has
   * since been deleted — simply falls back to the active year.
   */
  selectedYearId: string | null;
  setSelectedYearId: (id: string | null) => void;
}

export const useAcademicYearStore = create<AcademicYearState>()(
  persist(
    (set) => ({
      selectedYearId: null,
      setSelectedYearId: (selectedYearId) => set({ selectedYearId }),
    }),
    { name: 'academic-year-storage' }
  )
);
